import script from "./WaterfallRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./WaterfallRegister.vue?vue&type=script&setup=true&lang=js"

import "./WaterfallRegister.vue?vue&type=style&index=0&id=486366a3&setup=true&lang=css"

const __exports__ = script;

export default __exports__